// @/utils/pdfInvoiceGenerator.js

/**
 * PDF Invoice Generator Utility
 * ใช้สำหรับสร้าง PDF Invoice/Statement ด้วย pdfMake
 */

var convert = require("decimal-number-to-words");

class PDFInvoiceGenerator {
    constructor() {
        this.statementData = null;
        this.pdfMakeReady = false;
    }

    /**
     * ฟังก์ชันหลักสำหรับ Export PDF
     * @param {Object} invoiceData - ข้อมูล Invoice ที่ต้องการ Export
     * @returns {Promise<boolean>}
     */
    async exportToPDF(invoiceData) {
        try {
              // เก็บข้อมูลไว้
              this.statementData = invoiceData;

              // รอให้ pdfMake พร้อมใช้งาน
              await this.waitForPdfMakeReady();

              // สร้าง PDF
              const docDefinition = this.generateCombinedDocDefinitionForInvoice();

              // เปิด PDF ใหม่ในแท็บใหม่
              //ฟังก์ชันปริ้นเก่า
              //   pdfMake.createPdf(docDefinition).open();
              //   return true;

              //ฟังก์ชันปริ้นใหม่
              return await new Promise((resolve, reject) => {
                try {
                  pdfMake.createPdf(docDefinition).getBlob(resolve);
                } catch (e) {
                  reject(e);
                }
              });
            } catch (error) {
            console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
            throw error;
        }
    }

    /**
     * รอให้ pdfMake พร้อมใช้งาน
     * @returns {Promise<boolean>}
     */
    waitForPdfMakeReady() {
        return new Promise((resolve, reject) => {
            const checkInterval = setInterval(() => {
                if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
                    clearInterval(checkInterval);
                    console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
                    resolve(true);
                }
            }, 100);

            setTimeout(() => {
                clearInterval(checkInterval);
                reject(new Error("pdfMake โหลดไม่สำเร็จ"));
            }, 10000);
        });
    }

    /**
     * จัดฟอร์แมตตัวเลข
     * @param {number} value
     * @returns {string}
     */
    formatNumber(value) {
        if (!value && value !== 0) return "0.00";
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    }

    /**
     * จัดฟอร์แมตวันที่
     * @param {string} dateString
     * @returns {string}
     */
    formatDate(dateString) {
        if (!dateString) return "";
        if (dateString.includes("/")) {
            return dateString;
        }

        const date = new Date(dateString);
        const day = date
            .getDate()
            .toString()
            .padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    /**
     * สร้างเนื้อหาหลักของ Statement
     * @param {string} documentType - "ORIGINAL" หรือ "COPY"
     * @returns {Array}
     */
    generateMainStatement(documentType = "ORIGINAL") {
        const mainContent = [];
        const header = this.statementData?.print_header || {};
        console.log(header)
        const items = this.statementData?.datashowAll?.flat() || [];
        // const items = [...this.statementData?.datashowAll?.flat(),...this.statementData?.datashowAll?.flat(),...this.statementData?.datashowAll?.flat()] || [];
        const showcurrency = this.statementData?.showcurrency || "USD";


        // คำนวณจำนวน items ต่อหน้า
        // const totalItems = items.length;
        // const itemsPerPage = totalItems <= 12 ? 12 : 20; // เปลี่ยนจาก 8 และ 13 เป็น 12 และ 20

        // ตรวจสอบชื่อบริษัทเพื่อกำหนด Disclaimer

        const isLawOffice =
            header.com_thai === "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์";
        const disclaimerText = isLawOffice
            ? "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt."
            : "Dej-Udom & Associates Ltd. shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates Ltd. for verification if in doubt.";


        // ตรวจสอบภาษาของลูกค้า
        const checker_th = /([\u0E00-\u0E7F]+)/gmu;
        const isThaiCustomer = checker_th.test(header.customer_name || "");

        // กำหนดจำนวนเงินตัวอักษร
        let amountInWords = "";
        if (isThaiCustomer) {
            amountInWords = this.statementData.textamount_total_en || "";
        } else {
            amountInWords = `(${this.statementData.textamount_total_en ||
                ""}) ${showcurrency}`;
        }
        amountInWords = amountInWords.replace("US", "USD").replace("USDD", "USD");

        const itemstest = [
            { report_desc: 'test', report_amount: 200.00 },
            { report_desc: 'รายการที่ 2รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่ รายการที่ รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่รายการที่', report_amount: 150.00 },
            { report_desc: 'รายการที่ 3', report_amount: 300.00 },
            { report_desc: 'รายการที่ 4', report_amount: 450.00 },
            { report_desc: 'รายการที่ 5', report_amount: 175.50 },
            { report_desc: 'รายการที่ 6', report_amount: 225.75 },
            { report_desc: 'รายการที่ 7', report_amount: 350.00 },
            { report_desc: 'รายการที่ 8', report_amount: 125.25 },
            { report_desc: 'รายการที่ 9', report_amount: 275.80 },
            { report_desc: 'รายการที่ 10', report_amount: 400.00 },
            { report_desc: 'รายการที่ 11', report_amount: 180.50 },
            { report_desc: 'รายการที่ 12', report_amount: 320.75 },
            { report_desc: 'รายการที่ 13', report_amount: 195.00 },
            { report_desc: 'รายการที่ 14', report_amount: 240.50, first_item: 1, report_type: "ADMIS" },
            { report_desc: 'รายการที่ 15', report_amount: 385.25 },
            { report_desc: 'รายการที่ 16', report_amount: 160.00 },
            { report_desc: 'รายการที่ 17', report_amount: 290.75 },
            { report_desc: 'รายการที่ 18', report_amount: 215.50 },
            { report_desc: 'รายการที่ 19', report_amount: 340.00 },
            { report_desc: 'รายการที่ 20', report_amount: 425.80 },
            { report_desc: 'รายการที่ 21', report_amount: 190.25 },
            { report_desc: 'รายการที่ 22', report_amount: 265.50 },
            { report_desc: 'รายการที่ 23', report_amount: 310.00 },
            { report_desc: 'รายการที่ 24', report_amount: 145.75 },
            { report_desc: 'รายการที่ 25', report_amount: 375.50 },
            { report_desc: 'รายการที่ 26', report_amount: 220.00 },
            { report_desc: 'รายการที่ 27', report_amount: 295.25 },
            { report_desc: 'รายการที่ 28', report_amount: 165.80 },
            { report_desc: 'รายการที่ 29', report_amount: 330.50 },
            { report_desc: 'รายการที่ 30', report_amount: 410.00 },
            { report_desc: 'รายการที่ 31', report_amount: 185.75 },
            { report_desc: 'รายการที่ 32', report_amount: 255.50 },
            { report_desc: 'รายการที่ 33', report_amount: 325.00 },
            { report_desc: 'รายการที่ 34', report_amount: 170.25 },
            { report_desc: 'รายการที่ 35', report_amount: 390.80 },
            { report_desc: 'รายการที่ 36', report_amount: 210.50 },
            { report_desc: 'รายการที่ 37', report_amount: 280.00 },
            { report_desc: 'รายการที่ 38', report_amount: 155.75 },
            { report_desc: 'รายการที่ 39', report_amount: 345.50 },
            { report_desc: 'รายการที่ 40', report_amount: 435.25 },
            { report_desc: 'รายการที่ 41', report_amount: 205.00 },
            { report_desc: 'รายการที่ 42', report_amount: 270.75 },
            { report_desc: 'รายการที่ 43', report_amount: 315.50 },
            { report_desc: 'รายการที่ 44', report_amount: 140.00 },
            { report_desc: 'รายการที่ 45', report_amount: 365.80 },
            { report_desc: 'รายการที่ 46', report_amount: 230.25 },
            { report_desc: 'รายการที่ 47', report_amount: 305.50 },
            { report_desc: 'รายการที่ 48', report_amount: 175.00 },
            { report_desc: 'รายการที่ 49', report_amount: 355.75 },
            { report_desc: 'รายการที่ 50', report_amount: 420.50 },
        ];

        if (["D", "L"].includes(header.company_inv)) {

            header.com_eng_1 = header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.";
            header.com_eng_2 = header.com_eng_2 || "ATTORNEYS AT LAW";
            header.com_thai = header.com_thai || "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด";
            header.com_add_name = header.com_add_name || "CHARN ISSARA TOWER 1, 2nd FLOOR,";
            header.com_add_no = header.com_add_no || "942/69 RAMA IV ROAD,";
            header.com_add_city = header.com_add_city || "KWAENG SURIYAWONG, KHET BANGRAK,";
            header.com_add_country = header.com_add_country || "BANGKOK 10500, THAILAND";
            header.com_add_tel = header.com_add_tel || "Tel : 0-2233-0055, 0-2267-5152";
            header.com_add_email = header.com_add_email || "E-MAIL : account@dejudom.com";
            header.com_add_tax_id = header.com_add_tax_id || 'TAX ID. No. 0105534015348/"HEAD OFFICE"';
        } else {

            header.com_eng_1 = header.com_name || "ไม่มีข้อมูลบริษัท";
            header.com_eng_2 = header.com_eng_2 || "";
            header.com_thai = header.inv_company_name_th || "ไม่มีข้อมูลบริษัท";
            header.com_add_name = `${header.inv_company_address},` || " ";

            if (header.inv_company_address2 && header.inv_company_address2 != "") {
                header.com_add_no = `${header.inv_company_address2},`;
            } else {
                header.com_add_no = ` `;
            }

            header.com_add_city = `${header.inv_subdistrict}, ${header.inv_subdistrict},`;
            header.com_add_country = `${header.inv_province}, ${header.inv_postcode}, ${header.inv_country}`;
            header.com_add_tel = `Tel : ${header.inv_company_tel}`;
            header.com_add_email = `E-MAIL : ${header.inv_company_email}`;
            header.com_add_tax_id = `TAX ID. No. ${header.inv_tax_id}/"${header.inv_company_branch}"`;

        }

        // ===== หน้าที่ 1 =====
        mainContent.push(
            // Header บริษัท
            {
                columns: [
                    {
                        width: "50%",
                        stack: [
                            {
                                text: header.com_eng_1,
                                fontSize: 16,
                                bold: true,
                                margin: [0, 0, 0, 1],
                            },
                            {
                                text: header.com_eng_2,
                                fontSize: 9,
                                margin: [0, 0, 0, 2],
                            },
                            {
                                text:
                                    header.com_thai,
                                fontSize: 11,
                                margin: [0, 0, 0, 1],
                            },
                        ],
                    },
                    {
                        width: "50%",
                        stack: [
                            {
                                text: header.com_add_name,
                                fontSize: 8,
                                alignment: "right",
                            },
                            {
                                text: header.com_add_no,
                                fontSize: 8,
                                alignment: "right",
                            },
                            {
                                text: header.com_add_city,
                                fontSize: 8,
                                alignment: "right",
                            },
                            {
                                text: header.com_add_country,
                                fontSize: 8,
                                alignment: "right",
                            },
                            {
                                text: header.com_add_tel,
                                fontSize: 8,
                                alignment: "right",
                                margin: [0, 2, 0, 0],
                            },
                            {
                                text: header.com_add_email,
                                fontSize: 8,
                                alignment: "right",
                            },
                            {
                                text:
                                    header.com_add_tax_id,
                                fontSize: 8,
                                alignment: "right",
                                bold: true,
                            },
                        ],
                    },
                ],
                margin: [0, 0, 0, 15],
            },



            // ตารางและข้อมูล
            this.generateItemsTable(items, header, documentType, showcurrency),
        );



        return mainContent;
    }

    /**
     * สร้างตารางรายการ
     */
    generateItemsTable(items, header, documentType, showcurrencydata) {
        const showcurrency = showcurrencydata;
        return {
            stack: [
                // STATEMENT พร้อม ORIGINAL/COPY
                {
                    columns: [
                        {
                            width: "70%",
                            text: header.com_title || "STATEMENT",
                            fontSize: 18,
                            bold: true,
                        },
                        {
                            width: "30%",
                            stack: [
                                {
                                    text: documentType,
                                    fontSize: 11,
                                    bold: true,
                                    alignment: "right",
                                    margin: [0, 0, 0, 2],
                                },
                                {
                                    text: `No. / เลขที่ : ${header.inv_id || ""}`,
                                    fontSize: 10,
                                    alignment: "right",
                                },
                            ],
                        },
                    ],
                    margin: [0, 0, 0, 5],
                },

                // เส้นคั่น
                {
                    canvas: [
                        {
                            type: "line",
                            x1: 0,
                            y1: 0,
                            x2: 545,
                            y2: 0,
                            lineWidth: 1,
                        },
                    ],
                    margin: [0, 0, 0, 10],
                },

                // ข้อมูลลูกค้า
                {
                    columns: [
                        {
                            width: "55%",
                            stack: [
                                {
                                    text: [
                                        { text: "To / ถึง:  ", fontSize: 10 },
                                        {
                                            text: header.customer_name || "",
                                            fontSize: 10,
                                            bold: true,
                                        },
                                    ],
                                    margin: [0, 0, 0, 2],
                                },
                                {
                                    text: (header.addressall || "").split("\n"),
                                    fontSize: 9,
                                    margin: [0, 0, 0, 5],
                                },
                                {
                                    text: `Tax ID: ${header.customer_taxid || "0"} `,
                                    fontSize: 9,
                                    margin: [0, 3, 0, 2],
                                },
                                {
                                    text: `Attention : ${header.attention ||
                                        header.customer_contact_name ||
                                        "-"}`,
                                    fontSize: 9,
                                },
                            ],
                        },
                        {
                            width: "45%",
                            stack: [
                                {
                                    text: `Date / วันที่: ${header.invoice_date || "-"}`,
                                    fontSize: 9,
                                    alignment: "right",
                                    margin: [0, 0, 0, 8],
                                },
                                {
                                    text: `Period Covered / รอบระยะเวลา : ${header.period_cover ||
                                        "-"}`,
                                    fontSize: 9,
                                    alignment: "right",
                                    margin: [0, 0, 0, 2],
                                },
                                {
                                    text: `Document Ref. : ${header.docref || "-"}`,
                                    fontSize: 9,
                                    alignment: "right",
                                },
                                {
                                    text: `Credit Term : ${header.customer_paymentterm ||
                                        "-"} Days`,
                                    fontSize: 9,
                                    alignment: "right",
                                },
                                {
                                    text: `Due Date : ${header.credit_term_date || "-"}`,
                                    fontSize: 9,
                                    alignment: "right",
                                },
                            ],
                        },
                    ],
                    margin: [0, 0, 0, 15],
                },
                //Fix Table page1
                {
                    absolutePosition: { x: 25, y: 243 }, // กำหนดตำแหน่งเริ่มต้นที่แน่นอน (x=ซ้าย-ขวา, y=บน-ล่าง)
                    table: {
                        headerRows: 1,
                        widths: [422, 120],
                        body: [
                            // Header row
                            [
                                {
                                    text: 'Description / รายการ',
                                    fontSize: 10,
                                    bold: true,
                                    margin: [5, 5, 5, 5]
                                },
                                {
                                    text: 'Amount / จำนวนเงิน',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'right',
                                    margin: [5, 5, 5, 5]
                                }
                            ],
                            // แถวว่างสำหรับกำหนดความสูง
                            [
                                {
                                    text: '',
                                    margin: [5, 3, 5, 3]
                                },
                                {
                                    text: '',
                                    margin: [5, 3, 5, 3]
                                }
                            ],
                        ],
                        heights: [25, this.statementData?.print_header.company_inv !== "L" ? 372 : 390] // header 25pt, content 365pt
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            if (i === 0 || i === 1) return 1;
                            if (i === node.table.body.length) return 1;
                            return 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === 1 || i === node.table.widths.length) ? 1 : 0;
                        },
                        hLineColor: function (i, node) {
                            return 'black';
                        },
                        vLineColor: function (i, node) {
                            return 'black';
                        },
                        paddingLeft: () => 0,
                        paddingRight: () => 0,
                        paddingTop: () => 0,
                        paddingBottom: () => 0,
                    }
                },
                // ตารางที่ 2: ตารางข้อมูลจริง (วางทับด้านบน)
                {
                    layout: {
                        hLineWidth: function (i, node) {
                            if (i === 0 || i === 1) return 1;
                            // if (i === node.table.body.length) return 1;
                            return 0;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === 1 || i === node.table.widths.length) ? 1 : 0;
                        },
                        hLineColor: function (i, node) {
                            return 'black';
                        },
                        vLineColor: function (i, node) {
                            return 'black';
                        }
                    },
                    table: {
                        headerRows: 1,
                        widths: [422, 112],
                        body: [
                            [
                                {
                                    text: '',
                                    fontSize: 10,
                                    bold: true,
                                    margin: [5, 5, 5, 5]
                                },
                                {
                                    text: '',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'right',
                                    margin: [5, 5, 5, 5]
                                }
                            ],
                            ...items.map(item => [
                                {
                                    text: item.first_item === 1 && item.report_type === "ADMIS"
                                        ? [
                                            {
                                                text: "\nMiscellaneous Disbursement:\n",
                                                bold: true,
                                                fontSize: 9,
                                                margin: [5, 3, 5, 0],
                                            },
                                            {
                                                text: item.report_desc?.trim() || "",
                                                margin: [5, 3, 5, 0],
                                                fontSize: 9,
                                            },
                                        ]
                                        : item.report_desc?.trim() || "",
                                    fontSize: 9,
                                    // lineHeight: 1.1,
                                    margin: [5, 3, 5, 0],
                                },
                                {
                                    text: item.first_item === 1 && item.report_type === "ADMIS"
                                        ? [
                                            {
                                                text: "\n\n",
                                                bold: true,
                                                fontSize: 9,
                                                alignment: 'right',
                                                margin: [5, 3, 5, 0],
                                            },
                                            {
                                                text: item.report_amount && item.report_amount !== 0
                                                    ? this.formatNumber(item.report_amount)
                                                    : "",
                                                alignment: 'right',
                                                fontSize: 9,
                                                margin: [5, 3, 5, 0],
                                            },
                                        ]
                                        : item.report_amount && item.report_amount !== 0
                                            ? this.formatNumber(item.report_amount)
                                            : "",
                                    alignment: 'right',
                                    fontSize: 9,
                                    // lineHeight: 1.1,
                                    margin: [5, 3, 5, 0],
                                },
                            ]),
                            ...(showcurrency !== "THB" ? [[
                                {
                                    text:
                                        "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes;\nwe will solely be responsible for Thai tax.",
                                    fontSize: 8,
                                    italics: true,
                                    bold: true,
                                    margin: [5, 5, 5, 5],
                                },
                                {},
                            ]] : []),
                            // [
                            //   {
                            //     text: '',
                            //     margin: [5, 3, 5, 3]
                            //   },
                            //   {
                            //     text: '',
                            //     margin: [5, 3, 5, 3]
                            //   }
                            // ]
                        ],
                        heights: (rowIndex) => {
                            if (rowIndex === 0) return 20;
                            return 'auto';
                        }
                    },
                    layout: 'noBorders',
                    margin: [0, 0, 0, 0]
                },
            ]
        }
    }


    createFooterfirstpage() {
        // เตรียม disclaimerText สำหรับ footer
        const header = this.statementData?.print_header || {};
        const showcurrency = this.statementData?.showcurrency || "USD";

        var disclaimerText = "";
        var textFooter = "";
        if (["D", "L"].includes(header.company_inv)) {
            textFooter = "Cybersecurity & Wire Transfer Disclaimer";
            const isLawOffice =
                header.com_thai === "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์";
            disclaimerText = isLawOffice
                ? "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt."
                : "Dej-Udom & Associates Ltd. shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates Ltd. for verification if in doubt.";
        } else {
            textFooter = "";
        }

        // กำหนดจำนวนเงินตัวอักษร
        const checker_th = /([\u0E00-\u0E7F]+)/gmu;
        const isThaiCustomer = checker_th.test(header.customer_name || "");
        let amountInWords = "";
        if (isThaiCustomer) {
            amountInWords = this.statementData.textamount_total_en || "";
        } else {
            amountInWords = `(${this.statementData.textamount_total_en ||
                ""}) ${showcurrency}`;
        }
        amountInWords = amountInWords.replace("US", "USD").replace("USDD", "USD");
        return {
            stack: [
                {
                    table: {
                        widths: [422, 120],
                        body: [
                            [
                                {
                                    text: "Sub Total / รวมเป็นเงิน",
                                    fontSize: 10,
                                    margin: [5, 3, 5, 3],
                                },
                                {
                                    text:
                                        this.formatNumber(header.sub_total || 0) + " " + showcurrency,
                                    fontSize: 10,
                                    alignment: "right",
                                    margin: [5, 3, 5, 3],
                                },
                            ],
                            [
                                {
                                    text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${header.wth_rate ||
                                        "3.00"}%)`,
                                    fontSize: 10,
                                    margin: [5, 3, 5, 3],
                                },
                                {
                                    text:
                                        this.formatNumber(header.wth_rate_amount || 0) +
                                        " " +
                                        showcurrency,
                                    fontSize: 10,
                                    alignment: "right",
                                    margin: [5, 3, 5, 3],
                                },
                            ],
                            ...(header.company_inv !== "L"
                                ? [[
                                    {
                                        text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${header.tax_rate ||
                                            "7.00"}%)`,
                                        fontSize: 10,
                                        margin: [5, 3, 5, 3],
                                    },
                                    {
                                        text:
                                            this.formatNumber(header.tax_rate_amount || 0) +
                                            " " +
                                            showcurrency,
                                        fontSize: 10,
                                        alignment: "right",
                                        margin: [5, 3, 5, 3],
                                    },
                                ]]
                                : []),
                            [
                                {
                                    text: "Grand Total / ยอดรวม",
                                    fontSize: 11,
                                    bold: true,
                                    fillColor: "#eeeeee",
                                    margin: [5, 5, 5, 3],
                                },
                                {
                                    text:
                                        this.formatNumber(header.amount_total || 0) +
                                        " " +
                                        showcurrency,
                                    fontSize: 11,
                                    bold: true,
                                    alignment: "right",
                                    fillColor: "#eeeeee",
                                    margin: [5, 5, 5, 3],
                                },
                            ],
                            [
                                {
                                    text: amountInWords,
                                    fontSize: 10,
                                    alignment: "center",
                                    fillColor: "#eeeeee",
                                    margin: [5, 5, 5, 3],
                                    colSpan: 2,
                                },
                                {},
                            ],
                        ],
                    },
                    layout: {
                        //   hLineWidth: (i) => {
                        //   if (i === 0) return 0; // ไม่มีเส้นบนสุดเพื่อให้ชิดกับตารางด้านบน
                        //   return 1;
                        // },
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        paddingLeft: () => 0,
                        paddingRight: () => 0,
                        paddingTop: () => 0,
                        paddingBottom: () => 0,
                    },
                    margin: [25, 0, 25, 0],
                },
                // Please send section
                {
                    stack: [
                        {
                            text:
                                "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                            fontSize: 8,
                            alignment: "center",
                            margin: [25, 5, 25, 1],
                        },
                        {
                            text:
                                "โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                            fontSize: 8,
                            alignment: "center",
                            margin: [25, 0, 25, 5],
                        },
                    ],
                },
                {
                    text: textFooter,
                    fontSize: 8,
                    bold: true,
                    color: "red",
                    margin: [25, 5, 25, 2],
                },
                {
                    text: disclaimerText,
                    fontSize: 7,
                    bold: true,
                    color: "red",
                    alignment: "justify",
                    margin: [25, 0, 25, 10],
                },
            ],
            margin: [0, 0, 0, 0],
        }
    };
    createFooterotherpage() {
        return {
            stack: [
                {
                    table: {
                        headerRows: 1,
                        absolutePosition: { x: 25, y: 10 },
                        widths: [414, 112],
                        body: [
                            // Header row
                            [
                                {
                                    text: 'Description / รายการ',
                                    fontSize: 10,
                                    bold: true,
                                    margin: [5, 5, 5, 5]
                                },
                                {
                                    text: 'Amount / จำนวนเงิน',
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'right',
                                    margin: [5, 5, 5, 5]
                                }
                            ],
                            [
                                {
                                    text: '',
                                    margin: [5, 3, 5, 3]
                                },
                                {
                                    text: '',
                                    margin: [5, 3, 5, 3]
                                }
                            ],
                        ],
                        heights: [25, 760]
                    },
                    layout: {
                        hLineWidth: function (i, node) {
                            if (i === 0 || i === 1) return 1;
                            if (i === node.table.body.length) return 1;
                            return 1;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === 1 || i === node.table.widths.length) ? 1 : 0;
                        },
                        hLineColor: function (i, node) {
                            return 'black';
                        },
                        vLineColor: function (i, node) {
                            return 'black';
                        }
                    },
                    margin: [25, this.statementData?.print_header.company_inv !== "L" ? -630 : -645, 25, -200]
                },
            ],
            margin: [0, 0, 0, -200]
        };
    };

    /**
     * สร้าง PDF Definition ที่มีทั้ง ORIGINAL และ COPY
     * @returns {Object}
     */
    generateCombinedDocDefinitionForInvoice() {
        const originalContent = this.generateMainStatement("ORIGINAL");
        const copyContent = this.generateMainStatement("COPY");


        const header = this.statementData?.print_header || {};

        // เพิ่ม pageBreak ให้ COPY
        copyContent[0] = {
            ...copyContent[0],
            pageBreak: "before",
        };


        return {
            pageSize: "A4",
            pageMargins: [25, 25, 25, header.company_inv !== "L" ? 200 : 182], // เพิ่ม bottom margin สำหรับ footer
            content: [...originalContent, ...copyContent],
            //   content: function(currentPage, pageCount, pageSize) {
            //       if (currentPage === 1 || currentPage == ((pageCount/2)+1)) {
            //   console.log('This is the contentcontent first page.');
            //   // return {  
            //   //   margin: [25, 25, 25, 50]  // กำหนด margin สำหรับหน้าที่ไม่ใช่หน้าแรก
            //   // }

            // } else {
            //   console.log('This is not the contentcontent first page. 2+');
            //   return {  
            //     margin: [25, 25, 25, 50]  // กำหนด margin สำหรับหน้าที่ไม่ใช่หน้าแรก
            //   }
            // }
            //      },
            header: function (currentPage, pageCount, pageSize) {
                if (currentPage === 1 || currentPage == ((pageCount / 2) + 1)) {
                    console.log('This is the first page.');

                } else {
                    console.log('This is not the first page. 2+');
                }
            },
            footer: (currentPage, pageCount) => {
                if (currentPage == 1 || currentPage == ((pageCount / 2) + 1)) {
                    return {
                        stack: [
                            this.createFooterfirstpage(),
                        ],
                        margin: [0, 0, 0, 0],
                    };
                } else {
                    return {
                        stack: [
                            this.createFooterotherpage(),
                        ],
                        margin: [0, 0, 0, 0],
                    }
                };
            },
            defaultStyle: {
                font: "Sarabun",
                fontSize: 10,
            },
        };
    }
}

// Export instance
export default new PDFInvoiceGenerator();
